import { RootState } from '@/plugins/store';
import { ActionTree, Commit } from 'vuex';
import { MonCompteState } from './state';
import { MonCompteModuleAction, MonCompteModuleActionTypes } from './actions-types';
import accountService from '@/modules/Account/services/AccountService';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import ErrorManager from '@/common/utils/ErrorManager';
import { MON_COMPTE } from '@/modules/MonCompte/store/mutation-types';
import i18n from '@/plugins/i18n';

const DELETE_ACCOUNT_STORAGE_KEY = 'deleteAccountRequested';

export const actions: ActionTree<MonCompteState, RootState> = {

    async [MonCompteModuleAction.LOAD_INFORMATIONS]({ state, commit }: MonCompteModuleActionTypes){
        state.isLoading = true;
        try {
            const profilResponse = await accountService.getInformations();
            state.profil = profilResponse.data;
            const tableData = [{ label: i18n.global.t('modale.my.account.id'), value: state.profil.identifiant },
                { label: i18n.global.t('modale.my.account.name'), value: state.profil.nom },
                { label: i18n.global.t('modale.my.account.firstname'), value: state.profil.prenom }];

            const tableData2 = [{ label: i18n.global.t('modale.my.account.contact.email'), value: state.profil.adresseMail }];

            return {tableData, tableData2};
        } catch (e) {
            commit(MON_COMPTE.SET_MODAL, false);
            await onError(e, commit);
        } finally {
            state.isLoading = false;
        }
    },

    async [MonCompteModuleAction.LOAD_DELETE_ACCOUNT_REQUESTED]({ state }: MonCompteModuleActionTypes){
        const storedValue = localStorage.getItem(DELETE_ACCOUNT_STORAGE_KEY);
        state.isDeleteAccountRequested = storedValue === 'true';
    },


    async [MonCompteModuleAction.SAVE_MOBILE_PHONE]({ state, commit }: MonCompteModuleActionTypes, tel: string){
        state.isMobilePhoneSaving = true;
        try {
            await accountService.saveMobilePhone(tel);
            state.profil.telephonePortable = tel;
        } catch (e) {
            await onError(e, commit);
        } finally {
            state.isMobilePhoneSaving = false;
        }
    },

    async [MonCompteModuleAction.SAVE_PHONE]({ state, commit }: MonCompteModuleActionTypes, tel: string){
        state.isPhoneSaving = true;
        try {
            await accountService.savePhone(tel);
            state.profil.telephoneFixe = tel;
        } catch (e) {
            await onError(e, commit);
        } finally {
            state.isPhoneSaving = false;
        }
    },

    async [MonCompteModuleAction.SAUVEGARDER_MDP]({ state, commit }: MonCompteModuleActionTypes, mdp: string){
        state.isPhoneSaving = true;
        try {
            await accountService.saveMdp(mdp);
        } catch (e) {
            await onError(e, commit);
        } finally {
            state.isPhoneSaving = false;
        }
    },

    async [MonCompteModuleAction.DEMANDER_SUPPRESSION_COMPTE]({ state, commit }: MonCompteModuleActionTypes){
        try {
            await accountService.demanderSuppressionCompte();
            state.isDeleteAccountRequested = true;
            localStorage.setItem(DELETE_ACCOUNT_STORAGE_KEY, 'true');
        } catch (e) {
            await onError(e, commit);
        }
    },

};

async function onError(error: any, commit: Commit) {
    commit(
        `errorToaster/${ERROR.SET_MESSAGE}`,
        await ErrorManager.processError(error),
        {root: true}
    );
}
